import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
  minutesAgo: number;
}
const PURCHASES: Purchase[] = [{
  name: 'Laura Gómez',
  city: 'General Roca',
  minutesAgo: 4
}, {
  name: 'Marcelo Díaz',
  city: 'Córdoba',
  minutesAgo: 9
}, {
  name: 'Sandra Pérez',
  city: 'Rosario',
  minutesAgo: 2
}, {
  name: 'Jorge Fernández',
  city: 'Mendoza',
  minutesAgo: 12
}, {
  name: 'Patricia López',
  city: 'La Plata',
  minutesAgo: 6
}, {
  name: 'Roberto Sosa',
  city: 'Mar del Plata',
  minutesAgo: 3
}, {
  name: 'Mónica Ríos',
  city: 'Salta',
  minutesAgo: 8
}, {
  name: 'Daniel Romero',
  city: 'Tucumán',
  minutesAgo: 5
}];
export function SocialProofToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: ReturnType<typeof setTimeout>;
    let hideTimer: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        showTimer = setTimeout(() => {
          setIndex(prev => (prev + 1) % PURCHASES.length);
          cycle();
        }, 4000);
      }, 5000);
    };
    showTimer = setTimeout(cycle, 3500);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const purchase = PURCHASES[index];
  return <div className="fixed bottom-4 left-4 z-[60] max-w-[calc(100%-2rem)] sm:max-w-sm pointer-events-none" data-id="element-162">
      <AnimatePresence data-id="element-163">
        {visible && !dismissed && <motion.div initial={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto relative bg-white rounded-2xl shadow-2xl border border-stone-100 px-4 py-3 flex items-center gap-3" role="status" aria-live="polite" data-id="element-164">
            <CheckCircle2Icon className="w-9 h-9 text-brand-600 shrink-0" data-id="element-165" />
            <div className="pr-5" data-id="element-166">
              <p className="font-bold text-brand-700 text-sm leading-tight" data-id="element-167">
                {purchase.name}, de {purchase.city}
              </p>
              <p className="text-xs text-stone-500 leading-tight" data-id="element-168">
                Acaba de comprar · Hace {purchase.minutesAgo} minutos
                <br data-id="element-169" />
                <span className="text-brand-600 font-medium" data-id="element-170">
                  ✓ Compra Verificada
                </span>
              </p>
            </div>
            <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-stone-300 hover:text-stone-500 transition-colors" data-id="element-171">
              <XIcon className="w-4 h-4" data-id="element-172" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}